import {ListTodo} from 'lucide-react';
import NextListItemTool from './tools/NextListItemTool';

export const OVERLAY_TOOL_ID_NEXT_LIST_ITEM = 'nextListItem';

export const overlayTools = [
	{
		id: OVERLAY_TOOL_ID_NEXT_LIST_ITEM,
		titleMessageId: 'List processing',
		icon: ListTodo,
		Component: NextListItemTool,
	},
];

export const overlayToolsById = overlayTools.reduce((acc, tool) => {
	acc[tool.id] = tool;
	return acc;
}, {});
